import { FC, Fragment } from 'react';
import { PerformCustomText } from '../perform-indicator/perform-indicator';
import * as Styles from './segment-parts.module.less';
import { MarketingBehaviorFilterDto } from '@servicetitan/application-data/marketing';
import { InteractionTypeToTextMap } from '../../utils/utils';

interface MarketingBehaviorProps {
    marketingBehavior: MarketingBehaviorFilterDto;
}

export const MarketingBehavior: FC<MarketingBehaviorProps> = ({ marketingBehavior }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Marketing Behavior</div>
        <div>
            <PerformCustomText
                name="Campaigns"
                value={`${
                    marketingBehavior.campaign
                        ? marketingBehavior.campaign.name
                        : 'No campaign selected'
                }, ${InteractionTypeToTextMap.get(marketingBehavior.interactionType!)}`}
            />
        </div>
    </Fragment>
);
